export const ROUTE_PATH = '/benefits-archive';

export const FEATURE_NAME = 'benefitItemsPage';
